import React, { useState } from 'react'
import UiYearSelect from '../../../_uiComponents/form/UiYearSelect'
import { UiButton } from '../../../_uiComponents/form/UiButton'

export default function TaxReportDownloadForm() {
    const [year, setYear] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const years = [
        { value: 2026, label: '2026' },
        { value: 2027, label: '2027' },
        { value: 2028, label: '2028' },
        { value: 2029, label: '2029' },
        { value: 2030, label: '2030' },
    ]

    const handleYearChange = (value) => {
        setYear(value);
        setError(null);
    }

    const handleDownload = async () => {
        if (!year) return;

        setLoading(true);
        setError(null);

        try {
            const response = await fetch('/api/user/download-tax-report', {
                method: 'GET',
            });

            if (!response.ok) throw new Error('Failed to download tax report');

            const disposition = response.headers.get('Content-Disposition');
            const match = disposition && disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            const filename = match ? match[1].replace(/['"]/g, '') : `tax-report-${year}`;

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            setError('Unable to download the tax report. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="tax-report-download-form">
                <h3>Tax Report Download</h3>
                <UiYearSelect placeholder="Select Year" options={years} onChange={handleYearChange} />
                {error && <p className="tax-report-download-form__error">{error}</p>}
                <div className="tax-report-download-form__button">
                    <UiButton title={loading ? 'Downloading...' : 'Download'} onClick={handleDownload} disabled={!year || loading} />
                </div>
            </div>
        </>
    )
}